import React from 'react';
import styled from 'styled-components';
import { Box } from 'src/kit/Box';
import logo1 from 'images/update_landing/companies/Alexa_Capital.png';
import logo3 from 'images/update_landing/companies/Banque-Hottinguer.png';
import logo4 from 'images/update_landing/companies/Cathay-Capital.png';
import logo5 from 'images/update_landing/companies/CNP.png';
import logo6 from 'images/update_landing/companies/D_Angelin_Co.png';
import logo7 from 'images/update_landing/companies/FDC.png';
import logo8 from 'images/update_landing/companies/Greenhill.png';
import logo9 from 'images/update_landing/companies/Infravia.png';
import logo10 from 'images/update_landing/companies/Meanings.png';
import logo11 from 'images/update_landing/companies/Sagard.png';
import logo12 from 'images/update_landing/companies/Zaoui&Co.png';

const ClientLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  filter: grayscale(100%);
  opacity: 0.6;
  transition: all 0.3s;

  &:hover {
    filter: grayscale(0%);
    opacity: 1;
  }

  img {
    width: auto;
    object-fit: contain;
  }
`;

const EmployerClients = () => {
  const logoData = [
    { src: logo1, height: 75 },
    { src: logo3, height: 45 },
    { src: logo4, height: 75 },
    { src: logo5, height: 60 },
    { src: logo6, height: 132 },
    { src: logo7, height: 45 },
    { src: logo8, height: 75 },
    { src: logo9, height: 75 },
    { src: logo10, height: 45 },
    { src: logo11, height: 75 },
    { src: logo12, height: 30 },
  ];

  return (
    <Box as="section" id="clients" style={{ background: '#fff', padding: '100px 5%', borderTop: '1px solid #e8ecf0' }}>
      <Box style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <Box style={{ textAlign: 'center', marginBottom: '56px' }}>
          <Box
            style={{
              fontSize: '0.75rem',
              fontWeight: 700,
              letterSpacing: '0.15em',
              textTransform: 'uppercase',
              color: '#2dbd96',
              marginBottom: '16px',
            }}
          >
            Trusted By
          </Box>
          <Box
            as="h2"
            style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: '2.5rem',
              fontWeight: 700,
              color: '#1a2332',
              marginBottom: '16px',
            }}
          >
            Preferred by leading PE firms and investment banks.
          </Box>
          <Box style={{ fontSize: '1rem', color: '#8a99a8', maxWidth: '600px', margin: '0 auto' }}>
            We work with some of the most prestigious names in finance to automate their junior recruitment.
          </Box>
        </Box>

        <Box
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '30px',
            alignItems: 'center',
          }}
        >
          {logoData.map((logo, i) => (
            <ClientLogo key={i}>
              <img src={logo.src} alt="client logo" style={{ height: logo.height }} />
            </ClientLogo>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default EmployerClients;
